
(function () {
  "use strict";

  function initNeviiveShippingPopup() {
    const popup = document.getElementById("NeviiveShippingPopup");

    if (!popup || popup.dataset.initialized === "true") {
      return;
    }

    popup.dataset.initialized = "true";

    const closeButton = popup.querySelector(
      ".neviive-shipping__close"
    );
    const continueButton = popup.querySelector(
      ".neviive-shipping__continue"
    );
    const overlay = popup.querySelector(
      ".neviive-shipping__overlay"
    );

    let pendingCheckout = null;
    let previousFocus = null;
    let bypassTarget = null;

    function findCheckoutControl(target) {
      if (!(target instanceof Element)) return null;

      return target.closest(
        'button[name="checkout"], ' +
        'input[name="checkout"], ' +
        'a[href*="/checkout"], ' +
        'button[data-checkout-button], ' +
        'a[data-checkout-button]'
      );
    }

    function openPopup(checkoutControl) {
      if (!popup.hidden) return;

      pendingCheckout = checkoutControl;
      previousFocus = document.activeElement;

      popup.hidden = false;
      popup.setAttribute("aria-hidden", "false");
      document.body.classList.add("neviive-shipping-open");

      closeButton.focus();
    }

    function closePopup() {
      popup.hidden = true;
      popup.setAttribute("aria-hidden", "true");
      document.body.classList.remove("neviive-shipping-open");

      if (
        previousFocus &&
        previousFocus.isConnected &&
        typeof previousFocus.focus === "function"
      ) {
        previousFocus.focus();
      }
    }

    document.addEventListener("click", function (event) {
      const checkoutControl = findCheckoutControl(event.target);

      if (!checkoutControl || popup.contains(checkoutControl)) {
        return;
      }

      if (bypassTarget === checkoutControl) {
        bypassTarget = null;
        return;
      }

      if (
        checkoutControl.disabled ||
        checkoutControl.getAttribute("aria-disabled") === "true"
      ) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      openPopup(checkoutControl);
    }, true);

    closeButton.addEventListener("click", closePopup);
    overlay.addEventListener("click", closePopup);

    document.addEventListener("keydown", function (event) {
      if (popup.hidden) return;

      if (event.key === "Escape") {
        event.preventDefault();
        closePopup();
      }
    });

    continueButton.addEventListener("click", function () {
      const target = pendingCheckout;

      closePopup();
      pendingCheckout = null;

      if (target && target.isConnected) {
        bypassTarget = target;
        target.click();
        bypassTarget = null;
      } else {
        window.location.assign("/checkout");
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initNeviiveShippingPopup,
      { once: true }
    );
  } else {
    initNeviiveShippingPopup();
  }
})();
